export const navItems = [
  { label: "projects", path: "/projects" },
  { label: "blog", path: "/blog" },
  { label: "contact", path: "#contact" },
];
